import React from 'react';
import useUserTimeline from 'hooks/API/GET/useUserTimeline';
import InfiniteLoaderBtn from 'components/InfiniteLoaderBtn';
// import DOMPurify from 'dompurify';
import addIcon from './icons/added.svg';
import deleted from './icons/deleted.svg';
import in_review from './icons/submitted_review.svg';
import marked_as_resolved from './icons/marked_as_resolved.svg';
import issue from './icons/issue.svg';
import rated from './icons/rated.svg';
import commented from './icons/commented.svg';

function TimeLine() {
  const { isLoading, isError, data, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useUserTimeline({
      enabled: true,
      configs: {
        params: { limit: 50 },
      },
    });

  return (
    <div className="mainWraper timeline-block">
      {isLoading ? (
        'Loading...'
      ) : isError ? (
        'Failed to load data'
      ) : (
        <>
          <h1>Activities</h1>
          <div className="timeline">
            {data?.pages.map((item, i) => {
              const { data: { result = [] } = {} } = item;
              return Object.entries(result).map(([key, value]) => {
                return (
                  <div className="tl-content tl-content-active" key={key}>
                    <div className="tl-header">
                      <p className="tl-title">{key}</p>
                    </div>
                    {value &&
                      value.map((_rcd, j) => {
                        return <LogActivity data={_rcd} key={j} />;
                      })}
                  </div>
                );
              });
            })}

            {/* START :: HTML UI TEMPLATE */}
            {/* <div className="tl-content tl-content-active">
            <div className="tl-header">
              <p className="tl-title">Thursday, 10 Aug</p>
            </div>
            <div className="tl-body">
              <div className="tl-marker">
                <span className="marker"></span>
              </div>
              <span className="profile">SL</span>
              <p>
                <b>Pellentesque</b> pretium tellus id mauris pretium, quis malesuada purus maximus.
              </p>
              <span className="time">4:42pm</span>
            </div>
          </div>
          <div className="tl-content">
            <div className="tl-header">
              <p className="tl-title">Thursday, 3 Aug</p>
            </div>
            <div className="tl-body">
              <div className="tl-marker">
                <span className="marker"></span>
              </div>
              <span className="profile">SL</span>
              <p>
                <b>Pellentesque</b> pretium tellus id mauris pretium, quis malesuada purus maximus.
              </p>
              <span className="time">4:42pm</span>
            </div>
            <div className="tl-body">
              <div className="tl-marker">
                <span className="marker"></span>
              </div>
              <span className="profile">SL</span>
              <p>
                <b>Pellentesque</b> pretium tellus id mauris pretium, quis malesuada purus maximus.
              </p>
            </div>
            <div className="tl-body">
              <div className="tl-marker">
                <span className="marker"></span>
              </div>
              <span className="profile">SL</span>
              <p>
                Lorem Ipsum is simply dummy text of the <b>printing and typesetting</b> industry.
                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
              </p>
              <span className="time">4:42pm</span>
            </div>
            <div className="tl-body">
              <div className="tl-marker">
                <span className="marker"></span>
              </div>
              <span className="profile">SL</span>
              <p>
                <b>Pellentesque</b> pretium tellus id mauris pretium, quis malesuada purus maximus.
              </p>
              <span className="time">4:42pm</span>
            </div>
          </div>
          <div className="tl-content">
            <div className="tl-header">
              <p className="tl-title">Wednesday, 1 Aug</p>
            </div>
            <div className="tl-body">
              <div className="tl-marker">
                <span className="marker"></span>
              </div>
              <span className="profile">SL</span>
              <p>
                <b>Pellentesque</b> pretium tellus id mauris pretium, quis malesuada purus maximus.
              </p>
              <span className="time">4:42pm</span>
            </div>
          </div> */}
            {/* END :: HTML UI TEMPLATE */}

            {isFetchingNextPage && 'Fetching...'}
            {typeof isLoading !== 'undefined' && isLoading !== true && !isFetchingNextPage && (
              <div>
                <InfiniteLoaderBtn
                  btnProps={{
                    onClick: () => fetchNextPage(),
                    disabled: !hasNextPage || isFetchingNextPage,
                  }}
                  rQueryProps={{ hasNextPage, isFetchingNextPage, fetchNextPage }}
                ></InfiniteLoaderBtn>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}

const LogActivity = ({ data }) => {
  function getFirstLetters(input) {
    const words = input.split(' ');
    if (words.length === 1) {
      return words[0].charAt(0);
    } else if (words.length >= 2) {
      return words[0].charAt(0) + words[1].charAt(0);
    }
    return '';
  }
  function getActivityNameAndIcon(key) {
    // console.log('🚀 ~ file: index.js:154 ~ getActivityNameAndIcon ~ key:', key.name);
    let v = {
      icon: `<span class="marker"></span>`,
      label: `<p>No action</p>`,
    };
    const { course, chapter, topic, subtopic, quiz, additionalData = {} } = key;
    const { rating, class: userClass } = key;
    const { currentRating } = rating || {};
    const { courseName = '' } = course || {};

    const { name: userClassName = '' } = userClass || {};
    const { name: chapterName = '' } = chapter || {};
    const { name: topicName = '' } = topic || {};
    const { name: subTopicName = '' } = subtopic || {};
    let { name: quizName = '' } = quiz || {};
    const {
      teacherId = {},
      modulename,
      seId,
      quizCategory,
      rating: givenRating,
      issueType,
    } = additionalData;
    const { name: teacherName, _id: teacher_id } = teacherId || {};
    const { name: seName, _id: se_id } = seId || {};

    let quizModuleName = null;
    const ratingStars = currentRating
      ? currentRating == '1'
        ? `1 star`
        : `${currentRating} stars`
      : '-';

    if (quizCategory) {
      if (quizCategory === 'mock_test') quizModuleName = 'Mock Test';
      if (quizCategory === 'previous_year') quizModuleName = 'Previous Year';
      if (quizCategory === 'question_bank') {
        quizModuleName = 'Question Bank';
        quizName = 'all ';
      }
      if (quizCategory === 'ncert_solutions') {
        quizModuleName = 'NCERT solutions(s)';
        quizName = 'all ';
      }
      if (quizCategory === 'past_papers') {
        quizModuleName = 'Past Papers(s)';
        quizName = 'all ';
      }
    }

    switch (key.name) {
      case 'new_topic_added':
        v = {
          icon: `<img src=${addIcon} alt="SVG Image" class="svg_action_icon">`,
          label: `<p> Lesson added <b>"${topicName}"</b> on course <b> ${courseName} </b>, chapter <b> ${chapterName} </b> inside class <b>${userClassName}</b>.</p>`,
        };
        break;
      case 'new_subtopic_added':
        v = {
          icon: `<img src=${addIcon} alt="SVG Image" class="svg_action_icon">`,
          label: `<p> Sublesson added <b>"${subTopicName}"</b> in topic <b>"${topicName}"</b> on course <b> ${courseName} </b>, chapter <b> ${chapterName} </b> inside class <b>${userClassName}</b>.</p>`,
        };
        break;
      case 'new_question_added':
        v = {
          icon: `<img src=${addIcon} alt="SVG Image" class="svg_action_icon">`,
          label: `<p>Added new question in a quiz <b>${quizName}</b> from course <b>${courseName}</b> ${
            chapterName ? `and in chapter <b>${chapterName}</b>.` : ``
          } ${topicName ? `Topic name : <b>${topicName}</b>` : ``}</p>`,
        };
        break;
      case 'content_modified':
        v = {
          icon: `<span class="marker"></span>`,
          label: `<p>Modified content in a course <b>${courseName}</b> ${
            chapterName ? `and in chapter <b>${chapterName}</b>.` : ``
          } ${topicName ? `Topic name : <b>${topicName}</b>` : ``}. ${
            subtopic ? `Name: ${subtopic?.name}` : ``
          } inside class <b>${userClassName}</b>.</p>`,
        };
        break;

      case 'deleted_question':
        v = {
          icon: `<img src=${deleted} alt="SVG Image" class="svg_action_icon">`,
          label: `<p>Deleted a question from <b>${quizName} </b> in a course <b>${courseName}</b> ${
            chapterName ? `and in chapter <b>${chapterName}</b>.` : ``
          } ${topicName ? `Topic name : <b>${topicName}</b>` : ``}. ${
            subtopic ? `Name: <b>${subtopic?.name}</b>` : ``
          }</p>`,
        };
        break;
      case 'deleted_topic':
        v = {
          icon: `<img src=${deleted} alt="SVG Image" class="svg_action_icon">`,
          label: `<p>Deleted  lesson in a course <b>${courseName}</b> ${
            chapterName ? `and in chapter <b>${chapterName}</b>.` : ``
          } ${topicName ? `Topic name : <b>${topicName}</b>` : ``}. ${
            subtopic ? `Name: <b>${subtopic?.name}</b>` : ``
          } inside class <b>${userClassName}</b>.</p>`,
        };
        break;
      case 'deleted_subtopic':
        v = {
          icon: `<img src=${deleted} alt="SVG Image" class="svg_action_icon">`,
          label: `<p>Deleted sub lesson in a course <b>${courseName}</b> ${
            chapterName ? `and in chapter <b>${chapterName}</b>.` : ``
          } ${topicName ? `Topic name : <b>${topicName}</b>` : ``}. ${
            subtopic ? `Name: <b>${subtopic?.name}</b>` : ``
          } inside class <b>${userClassName}</b>.</p>`,
        };
        break;
      case 'note_given_to_se_review':
        v = {
          icon: `<img src=${in_review} alt="SVG Image" class="svg_action_icon">`,

          label: `<p>Assigned back to SE's review - <b>${courseName}</b> ${
            chapterName ? `and in chapter <b>${chapterName}</b>.` : ``
          } ${topicName ? `Topic name : <b>${topicName}</b>` : ``}. ${
            subtopic ? `Name: <b>${subtopic?.name}</b>` : ``
          } inside class <b>${userClassName}</b>.</p>`,
        };
        break;
      case 'note_given_for_qc_review':
        v = {
          icon: `<img src=${in_review} alt="SVG Image" class="svg_action_icon">`,
          label: `<p>Submitted note from <b>${courseName}</b> ${
            chapterName ? `and in chapter <b>${chapterName}</b>.` : ``
          } ${topicName ? `Topic name : <b>${topicName}</b>` : ``}. ${
            subtopic ? `Name: <b>${subtopic?.name}</b>` : ``
          } inside class <b>${userClassName}</b> to QC </p>`,
        };
        break;
      case 'note_given_for_teacher_review':
        v = {
          icon: `<img src=${in_review} alt="SVG Image" class="svg_action_icon">`,
          label: `<p>Submitted for Teacher's review: Notes from <b>${topicName}</b>. Lesson is from chapter <b>${chapterName}</b> and Course <b>${courseName}</b> inside class <b>${userClassName}</b>.</p>`,
        };
        break;
      case 'geek_given_for_teacher_review':
        v = {
          icon: `<img src=${in_review} alt="SVG Image" class="svg_action_icon">`,
          label: `<p>Submitted for Teacher's review: Geek corner from <b>${topicName}</b>. Course <b>${courseName}</b> inside class <b>${userClassName}</b>.</p>`,
        };
        break;
      case 'geek_given_to_se_review':
        v = {
          icon: `<img src=${in_review} alt="SVG Image" class="svg_action_icon">`,
          label: `<p>Geek corner assigned back to SE's review - <b>${courseName}</b> ${
            chapterName ? `and in chapter <b>${chapterName}</b>.` : ``
          }.</p>`,
        };
        break;
      case 'quiz_given_for_teacher_review':
        v = {
          icon: `<img src=${in_review} alt="SVG Image" class="svg_action_icon">`,
          label: `<p>Submitted <b>${quizName} </b> (${quizModuleName}) from course <b>${courseName}</b> in class <b>${userClassName}</b> ${
            chapterName ? `and in chapter <b>${chapterName}</b> ` : ``
          } ${topicName ? `Topic name : <b>${topicName}</b>` : ``} ${
            subtopic ? `Name: <b>${subtopic?.name}</b>` : ``
          } ${teacher_id ? `to teacher ${teacherName}` : ``} </p>`,
        };
        break;
      case 'quiz_given_back_se_review':
        v = {
          icon: `<span class="marker"></span>`,
          label: `<p>Assinged back <b>${quizName} </b> (${quizModuleName}) from course <b>${courseName}</b>  in class <b>${userClassName}</b> ${
            chapterName ? `and in chapter <b>${chapterName}</b>.` : ``
          } ${topicName ? `Topic name : <b>${topicName}</b>` : ``} ${
            subtopic ? `Name: <b>${subtopic?.name}</b>` : ``
          } ${se_id ? `back to SE - ${seName}` : ``} </p>`,
        };
        break;
      case 'added_new_issue':
        v = {
          icon: `<img src=${issue} alt="SVG Image" class="svg_action_icon">`,
          label: `<p> Issue is marked on <b>${modulename === 'note' ? 'note ' : 'question '}</b> ${
            topicName ? `@lesson  <b>${topicName}</b>,` : ``
          } ${
            chapterName ? `@chapter  <b>${chapterName}</b>,` : ``
          } @course is  <b>${courseName}</b> inside class <b>${userClassName}</b> ${
            issueType ? ` where as the issue marked is <b><u>${issueType}</u></b>` : ``
          }.</p>`,
        };
        break;
      case 'added_reply_to_an_issue':
        v = {
          icon: `<img src=${commented} alt="SVG Image" class="svg_action_icon">`,
          label: `<p> A reply was added to a comment @lesson - <b>${topicName}</b>, @chapter - <b>${chapterName}</b>, @course - <b>${courseName}</b> inside class <b>${userClassName}</b>.</p>`,
        };
        break;

      case 'responded_to_an_issue':
        v = {
          icon: `<img src=${marked_as_resolved} alt="SVG Image" class="svg_action_icon">`,
          label: `<p> Issue reported on note on chapter <b>${chapterName}</b> has been marked as done. </p>`,
        };
        break;
      case 'note_marked_as_verified':
        v = {
          icon: `<img src=${marked_as_resolved} alt="SVG Image" class="svg_action_icon">`,
          label: `<p> Marked as Verified on <b>${
            modulename === 'note' ? 'note ' : 'question '
          }</b> ${topicName ? `@lesson  <b>${topicName}</b>,` : ``} ${
            chapterName ? `@chapter  <b>${chapterName}</b>,` : ``
          } @course is  <b>${courseName}</b> inside class <b>${userClassName}</b>.</p>`,
        };
        break;
      case 'resolved_an_issue': {
        if (!topic) {
          v = {
            icon: `<img src=${marked_as_resolved} alt="SVG Image" class="svg_action_icon">`,
            label: `<p> Issue reported in quiz on chapter <b>${chapterName}</b> has been resolved.</p>`,
          };
          break;
        }

        v = {
          icon: `<img src=${marked_as_resolved} alt="SVG Image" class="svg_action_icon">`,
          label: `<p> Issue reported on note on chapter <b>${chapterName}</b> has been resolved. </p>`,
        };
        break;
      }
      case 'added_rating_to_a_question':
        v = {
          icon: `<img src=${rated} alt="SVG Image" class="svg_action_icon">`,
          label: `<p> Added rating to question in <b>${quizName} </b> - Rating: <b>${ratingStars}</b>. </p>`,
        };
        break;
      case 'added_rating_to_note':
        v = {
          icon: `<img src=${rated} alt="SVG Image" class="svg_action_icon">`,
          label: `<p> Added rating to note in <b>${topicName} </b> - Rating: <b>${ratingStars}</b>. </p>`,
        };
        break;
      case 'updated_rating_to_note':
        v = {
          icon: `<img src=${rated} alt="SVG Image" class="svg_action_icon">`,
          label: `<p>Rating given to note in <b>${topicName}</b> has been updated - Rating: <b>${ratingStars}</b>. </p>`,
        };
        break;
      case 'updated_rating_to_a_question':
        v = {
          icon: `<img src=${rated} alt="SVG Image" class="svg_action_icon">`,
          label: `<p> Updated rating to question in <b>${quizName}</b> - Rating: <b>${ratingStars}</b>. </p>`,
        };
        break;

      default:
        console.log(key.name);
        break;
    }
    return v;
  }
  const { icon, label } = getActivityNameAndIcon(data);

  return (
    <div className="tl-body align-items-center" key={data._id}>
      <div
        className={`tl-marker ${data.action}_icon`}
        dangerouslySetInnerHTML={{
          __html: icon,
        }}
      />
      <span className="profile">{getFirstLetters(data?.user)}</span>
      <div
        dangerouslySetInnerHTML={{
          __html: label,
        }}
      />
      {/* <p>
        <b>Pellentesque</b> pretium tellus id mauris pretium, quis malesuada purus maximus.
      </p> */}

      <span className="time __appColor">{data.time}</span>
    </div>
  );
};

export default TimeLine;
